<head>
	<!-- Google Tag Manager -->
  
	<script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>
  
	<!-- End Google Tag Manager -->
  </head>
  <!-- Google Tag Manager (noscript) -->
  
  <noscript>
	<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KB72W5J" height="0" width="0" style="display:none;visibility:hidden"></iframe>
  </noscript>
  
  <!-- End Google Tag Manager (noscript) -->
<div *ngIf="mobile">
    <div class="template" style="font-size:large">
        <div>
            <table>
                <tr>
                    <!-- <td style="padding-left: 2%; vertical-align: top;">
                        <div class="sticky2">
                <tr>
                    <td>
                        <audio controls>
                            <source src="https://drive.google.com/uc?id=1RR5OSehZtSdOtDF_7nc4if8z5GGPWtPU&export=download"
                                type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio><br /><br />
                    </td>
                </tr>
                <tr>
                    <td style="text-align:center;">
                        <a [routerLink]="['/information/5']"><i class="fa-solid fa-arrow-left fa-lg"></i></a>
                    </td>
                </tr>
    
        </div>
    
        </td> -->
                    <td style="padding-left:4%;
        padding-right:4%;
        padding-top: 5%;
        padding-bottom: 3%;">
                        <h1 style="color: #5ECE42">Runs on daily candles</h1><br />
                        In the context of executing an algorithm on the eToro platform, various terms are employed to
                        delineate
                        the
                        distinct features and functionalities of a trading strategy. One such term is "Runs on daily
                        candles,"
                        which
                        refers to the algorithm's reliance on daily candlestick data for implementing its trading
                        approach. To
                        better
                        understand this concept, it is essential to delve into the background of candlestick charts,
                        their
                        significance
                        in financial trading, and the benefits of employing daily candlesticks for algorithmic trading.
                        <br /><br />
                        Candlestick charts have their origins in 18th-century Japan, where they were initially used to
                        track the
                        price
                        of rice contracts. Since then, they have become an indispensable tool for traders and investors
                        globally,
                        enabling them to visualise the price movement of a wide range of financial assets, such as
                        stocks, ETFs,
                        and
                        cryptocurrencies. Unlike line or bar charts, candlestick charts offer a more comprehensive view
                        of the
                        market by
                        capturing four critical price points for a given period: the opening, closing, high, and low
                        prices.
                        These data
                        points are represented as candlesticks, with the body of the candle illustrating the difference
                        between
                        the
                        opening and closing prices, and the wicks or shadows representing the high and low prices.
                        <br /><br />
                        When an algorithm is said to "run on daily candles," it signifies that it operates on a daily
                        time
                        frame. In
                        other words, each candlestick embodies the price fluctuations of an asset within a single
                        trading day.
                        By using
                        daily candlestick data, the algorithm can scrutinise price trends, discern potential patterns,
                        and
                        formulate
                        well-informed trading decisions.
                        <br /><br />
                        Employing daily candlesticks in algorithmic trading carries several advantages. First, daily
                        candles
                        supply a
                        more comprehensive view of the market than intraday time frames, such as hourly or minute-based
                        candles.
                        By
                        focusing on daily price changes, the algorithm can filter out the "noise" typically associated
                        with
                        shorter time
                        frames, such as random price fluctuations and market volatility. This approach enables the
                        algorithm to
                        concentrate on more reliable and stable trends, potentially improving the accuracy of its
                        predictions
                        and
                        overall trading performance.
                        <br /><br />
                        Second, algorithms that operate on daily candles may have lower trading costs compared to those
                        that use
                        shorter
                        time frames. Since daily candlesticks encompass the entire trading day, the number of trades
                        executed by
                        the
                        algorithm is likely to be significantly less than those made by algorithms that rely on minute
                        or hourly
                        candles. As a result, the trader can save on transaction costs, such as spreads and commissions.
                        <br /><br />
                        Third, daily candlestick-based algorithms typically demand less computational power and time. By
                        analysing only
                        the end-of-day data, these algorithms can reduce the amount of data processing required, thereby
                        minimising
                        latency and the need for extensive computational resources. This can be particularly beneficial
                        for
                        individual
                        traders or those with limited resources.
                        <br /><br />
                        In summary, the term "Runs on daily candles" in the context of the eToro platform refers to an
                        algorithm
                        that
                        employs daily candlestick data for making trading decisions. By focusing on daily time frames,
                        such
                        algorithms
                        can benefit from a more comprehensive view of the market, reduced trading costs, and lower
                        computational
                        demands. This approach allows the algorithm to analyze market trends, identify patterns, and
                        make
                        well-informed
                        trading decisions to potentially enhance overall trading performance.
                        <span  scrolledTo #scrolledToElement="scrolledTo"></span>
                        <br /><br />
                        <h2>External Resources:</h2><br />
                        <h3>TradingView:</h3> This platform offers interactive charts and various technical indicators
                        for
                        trading, including
                        daily candles. You can use the platform to analyze the Nasdaq-100 Top 20 stocks and implement
                        your
                        monthly rotation
                        strategy. URL: <a href="https://www.tradingview.com/">https://www.tradingview.com/</a>
                    </td>
                </tr>
            </table>
        </div>
        <br/>
        <a class="readMoreFlex" [routerLink]="['/etoro']" (click)="capturePos()">Read More - News Feed</a><br/><br/>

        <section class="linkedIn">
            <div class="shell">
                <div class="section__content">
                    <a href="https://www.linkedin.com/company/cosmic-algorithm-limited/"
                        target="_blank" rel="noopener noreferrer"><img class="linkedImg" src="../../assets/img/Follow Us on LinkedIn.png" alt="Follow us on LinkedIn"/></a>
                </div>
            </div>
        </section>
    </div>
    <div [class.sticky2-mob-stop]="scrolledToElement.reached" [class.sticky2-mob]="scrolledToElement.notreached">
        <div class="row">
            <div class="col-auto" style="align-items: center;
                    display: grid;margin-left:2%">

<i [routerLink]="['/information/methodology']" class="fa-solid fa-arrow-left fa-3x"></i>
            </div>
            <div class="col" style="width: 70%;">
                <audio controls>
                    <source src="https://theapi.backseat-trader.com/Runs on daily candles.mp3"
                        type="audio/mpeg">
                    Your browser does not support the audio element.
                </audio>

            </div>
            <div class="col-auto" style="align-items: center;
            display: grid;margin-right:2%">

                <i [routerLink]="['/']" class="fa-solid fa-house fa-3x" (click)="removePos()"></i>
            </div>
        </div>

    </div>
</div>

<div *ngIf="!mobile">
    <div class="template" style="font-size:large">
        <div>
            <table>
                <tr>
                    <td style="padding-left: 2%; vertical-align: top;">
                        <div class="sticky2">
                <tr>
                    <td>
                        <audio controls>
                            <source
                                src="https://theapi.backseat-trader.com/Runs on daily candles.mp3"
                                type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio><br /><br />
                    </td>
                </tr>
                <tr>
                    <td style="text-align:center;">
                        <i [routerLink]="['/information/methodology']" class="fa-solid fa-arrow-left fa-lg"></i>
                    </td>
                </tr>
                <br/>
                <tr>
                    <td>                                
                        <span class="breadcrumbs">Home</span> / <span class="breadcrumbs">Information</span> / <span class="breadcrumbs">Methodology</span> / <span class="breadcrumbs">Runs on Daily Candles</span><br/>
                    </td>
                </tr>

        </div>

        </td>
        <td style="width: 79%;
                                padding-right: 19%;
                                padding-top: 3%;
                                padding-bottom: 3%;">
                                <!-- <span class="breadcrumbs">Home</span> / <span class="breadcrumbs">Information</span> / <span class="breadcrumbs">Methodology</span> / <span class="breadcrumbs">Runs on Daily Candles</span><br/> -->
            <h1 style="color: #5ECE42">Runs on daily candles</h1><br />
            In the context of executing an algorithm on the eToro platform, various terms are employed to delineate
            the
            distinct features and functionalities of a trading strategy. One such term is "Runs on daily candles,"
            which
            refers to the algorithm's reliance on daily candlestick data for implementing its trading approach. To
            better
            understand this concept, it is essential to delve into the background of candlestick charts, their
            significance
            in financial trading, and the benefits of employing daily candlesticks for algorithmic trading.
            <br /><br />
            Candlestick charts have their origins in 18th-century Japan, where they were initially used to track the
            price
            of rice contracts. Since then, they have become an indispensable tool for traders and investors
            globally,
            enabling them to visualise the price movement of a wide range of financial assets, such as stocks, ETFs,
            and
            cryptocurrencies. Unlike line or bar charts, candlestick charts offer a more comprehensive view of the
            market by
            capturing four critical price points for a given period: the opening, closing, high, and low prices.
            These data
            points are represented as candlesticks, with the body of the candle illustrating the difference between
            the
            opening and closing prices, and the wicks or shadows representing the high and low prices.
            <br /><br />
            When an algorithm is said to "run on daily candles," it signifies that it operates on a daily time
            frame. In
            other words, each candlestick embodies the price fluctuations of an asset within a single trading day.
            By using
            daily candlestick data, the algorithm can scrutinise price trends, discern potential patterns, and
            formulate
            well-informed trading decisions.
            <br /><br />
            Employing daily candlesticks in algorithmic trading carries several advantages. First, daily candles
            supply a
            more comprehensive view of the market than intraday time frames, such as hourly or minute-based candles.
            By
            focusing on daily price changes, the algorithm can filter out the "noise" typically associated with
            shorter time
            frames, such as random price fluctuations and market volatility. This approach enables the algorithm to
            concentrate on more reliable and stable trends, potentially improving the accuracy of its predictions
            and
            overall trading performance.
            <br /><br />
            Second, algorithms that operate on daily candles may have lower trading costs compared to those that use
            shorter
            time frames. Since daily candlesticks encompass the entire trading day, the number of trades executed by
            the
            algorithm is likely to be significantly less than those made by algorithms that rely on minute or hourly
            candles. As a result, the trader can save on transaction costs, such as spreads and commissions.
            <br /><br />
            Third, daily candlestick-based algorithms typically demand less computational power and time. By
            analysing only
            the end-of-day data, these algorithms can reduce the amount of data processing required, thereby
            minimising
            latency and the need for extensive computational resources. This can be particularly beneficial for
            individual
            traders or those with limited resources.
            <br /><br />
            In summary, the term "Runs on daily candles" in the context of the eToro platform refers to an algorithm
            that
            employs daily candlestick data for making trading decisions. By focusing on daily time frames, such
            algorithms
            can benefit from a more comprehensive view of the market, reduced trading costs, and lower computational
            demands. This approach allows the algorithm to analyze market trends, identify patterns, and make
            well-informed
            trading decisions to potentially enhance overall trading performance.
            <br /><br />
            <h2>External Resources:</h2><br />
            <h3>TradingView:</h3> This platform offers interactive charts and various technical indicators for
            trading, including
            daily candles. You can use the platform to analyze the Nasdaq-100 Top 20 stocks and implement your
            monthly rotation
            strategy. URL: <a href="https://www.tradingview.com/" target="_blank" rel="noopener noreferrer">https://www.tradingview.com/</a>
        </td>
        </tr>
        </table>
    </div>
        <a class="readMoreFlex" [routerLink]="['/etoro']" (click)="capturePos()">Read More - News Feed</a><br/><br/>

    <section class="linkedIn">
        <div class="shell">
            <div class="section__content">
                <a href="https://www.linkedin.com/company/cosmic-algorithm-limited/"
                    target="_blank" rel="noopener noreferrer"><img class="linkedImg" src="../../assets/img/Follow Us on LinkedIn.png" alt="Follow us on LinkedIn"/></a>
            </div>
        </div>
    </section>
</div>

</div>